package com.meistercharts.charts.pv.modulePlanning

import com.meistercharts.charts.pv.roofPlanning.Module

/**
 * Which icon is painted in the center of a single [Module] during module planning.
 */
enum class ModuleIcon {
  /**
   * No icon.
   */
  None,

  /**
   * The delete button is offered but not armed yet.
   */
  Delete,

  /**
   * The mouse is over the delete button: releasing deletes the module.
   */
  DeleteArmed,

  /**
   * The mouse is over the delete button of a deleted module: releasing restores it.
   */
  UndeleteArmed,
}
